import screen from "../api/screen";

export default {
  screen
};
